
















import {Component, Vue} from "vue-property-decorator";

@Component
export default class CompareTableHeaderAdd extends Vue {
  addButtonClicked() {
    this.$store.dispatch('compare/showCompareProductSelectModal');
  }
}
